import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TCommentWithAuthor, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Response structure from comments API
 */
interface CommentsResponse {
  comments: TCommentWithAuthor[];
  total: number;
}

/**
 * Query key for fetching comments on a post - non-hook version
 */
export const getPostCommentsQueryKey = (postId: string) => [ENTITY, 'comments', postId];

/**
 * Query key for fetching comments on a post
 */
export const useGetCommentsQueryKey = (postId: string) => getPostCommentsQueryKey(postId);

/**
 * Hook to fetch all comments on a post
 * Returns comments in chronological order
 *
 * @param postId - Post ID (UUID)
 */
export const useGetComments = (postId: string) => {
  return useQuery<TCommentWithAuthor[], TError>({
    queryKey: useGetCommentsQueryKey(postId),
    queryFn: async () => {
      const res = await axios.get<CommentsResponse>(`/community-hub/posts/${postId}/comments`);
      return res.data.comments;
    },
    enabled: !!postId,
    staleTime: 30 * 1000, // 30 seconds (comments change frequently)
  });
};
